<template>
  <div class="menu-tree">
    <el-tree
      v-loading="loading"
      :ref="treeConfig.id"
      :data="treeData"
      :node-key="treeConfig.nodeKey"
      :props="treeConfig.defaultProps"
      :show-checkbox="treeConfig.showCheckbox"
      :expand-on-click-node="false">
      <!--:render-content="renderContent">-->
    </el-tree>
  </div>
</template>
<script>
export default {
  props: {
    treeConfig: {
      id: 'tree',
      nodeKey: 'id',
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      showCheckbox: false
    }
  },
  data() {
    return {
      loading: false,
      checkNodeIds: [],
      treeData: [],
      btnPrivilegeIds: []
    }
  },
  methods: {
    // renderContent(h, { node, data, store }) {
    //   return (
    //     <span class="custom-tree-node">
    //     <span >{node.label}</span>
    //   <span class="menu-btn-list">
    //     {
    //       data.operationList && data.operationList.map((item,index) => {
    //       return <div class={["menu-btn el-checkbox__input",{'is-checked':this.btnPrivilegeIds.findIndex(id => id == item.id)>-1}]}>
    //       <span class="el-checkbox__inner" on-click={ () => this.btnChecked(item) }></span>
    //       <span class="btn-txt">{item.name}</span>
    //       </div>
    //     })
    // }
    // </span>
    //   </span>);
    // },
    // btnChecked(data) {
    //   let dataIndex = this.btnPrivilegeIds.findIndex(item => item == data.id);
    //   if (dataIndex > -1) {
    //     this.btnPrivilegeIds.splice(dataIndex, 1)
    //   } else {
    //     this.btnPrivilegeIds.push(data.id);
    //   }
    // },
    //返回目前半选中的节点的 key 所组成的数组
    getHalfCheckedKeys() {
      return this.$refs[this.treeConfig.id].getHalfCheckedKeys()
    },
    // 获取所有选择节点id，包括半选状态
    getCheckedIds(a, b, c) {
      let checkdIds = [];
      // this.$refs[this.treeConfig.id].getCheckedNodes().map(node => {
      //   checkdIds.push(node.id);
      //   checkdIds.push(node.parentId || node.pageId);
      // })
      // checkdIds = [...new Set(checkdIds), ...this.btnPrivilegeIds];
      // checkdIds = checkdIds.filter(item => item !== 0 && item != null && item != undefined && item !== '');
      checkdIds = (this.$refs[this.treeConfig.id].getHalfCheckedKeys()).concat(this.$refs[this.treeConfig.id].getCheckedKeys())
      // checkdIds = [...new Set(checkdIds), ...this.btnPrivilegeIds];
      checkdIds = checkdIds.filter(item => item !== 0 && item != null && item != undefined && item !== '');
      return checkdIds;
    },
    // 获取数据
    getTreeData(params) {
      this.loading = true;
      this.$axios.fetchGet(this.treeConfig.request.api + `?${this.$utils.JSONToString(this.treeConfig.request.param)}`, {}).then(data => {
        if (data.code == 200) {
          this.treeOriginalData = this.$utils.dealCascadeData(data.data);
          console.log(this.treeOriginalData)
          this.setCheckedIds(params);
          this.loading = false;
        } else {
          this.$message({message: data.msg, type: 'error'});
        }
      });
    },
    setCheckedIds(params) {
      this.btnPrivilegeIds = [];
      let checkedIds = [];
      this.treeOriginalData.map(item => {
        // 默认 首页
        if (item.url === '/index') {
          item.disabled = true
          item.markRole = true
        }
        if (item.markRole && item.children.length === 0) {
          checkedIds.push(item.id);
        }
        if (item.children != 0) {
          item.children.map(childrenItem => {
            //如果是管理员的话用户信息不可编辑
            if (childrenItem.name === '用户信息' && params.name === '管理员' && params.type === 10) {
              this.nonUpdateNode(childrenItem);
            }
            if (childrenItem.name === '支付设置' && params.type !== 10 && params.storeClass !== 2) {
              this.nonAllocationNode(childrenItem)
            }
            if (childrenItem.markRole && childrenItem.children.length === 0) {
              checkedIds.push(childrenItem.id);
            }
            if (childrenItem.children != 0) {
              childrenItem.children.map(grandchildren => {
                if (grandchildren.markRole && grandchildren.children.length === 0) {
                  checkedIds.push(grandchildren.id);
                }
                if (grandchildren.children != null) {
                  grandchildren.children.map(buttonChildren => {
                    if (buttonChildren.markRole) {
                      checkedIds.push(buttonChildren.id);
                    }
                  });
                }
              });
            }
          });
        }
      });
      this.treeData = [...this.treeOriginalData];
      this.$refs[this.treeConfig.id].setCheckedKeys(checkedIds);
    },

    nonUpdateNode(childrenItem) {
      childrenItem.disabled = true;
      if (childrenItem.children != 0) {
        childrenItem.children.map(grandchildren => {
          grandchildren.disabled = true;
          if (grandchildren.children != null) {
            grandchildren.children.map(buttonChildren => {
              buttonChildren.disabled = true;
            });
          }
        });
      }
    },
    nonAllocationNode(childrenItem) {
      childrenItem.disabled = true;
      childrenItem.markRole = false;
      if (childrenItem.children != 0) {
        childrenItem.children.map(grandchildren => {
          grandchildren.disabled = true;
          grandchildren.markRole = false;
          if (grandchildren.children != null) {
            grandchildren.children.map(buttonChildren => {
              buttonChildren.disabled = true;
              buttonChildren.markRole = false;
            });
          }
        });
      }
    },
  }
}
</script>

<style>
  .menu-tree .el-tree-node__content {
    line-height: 30px;
    height: auto;
    position: relative;
    align-items: unset;
    color: #333;
  }

  .menu-tree .menu-btn-list {
    margin-left: 20px;
    display: block;
    color: #333;
  }

  .menu-tree .menu-btn {
    margin-right: 10px;
    display: block;
    margin-bottom: 10px;
  }

  .menu-tree .menu-btn .btn-txt {
    margin-left: 5px;
  }

  .el-tree {
    height: 100%;
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/business/menuTreeTemplate.vue